module.exports = __webpack_public_path__ + "img/q6.bd775681.png";